module.exports = __webpack_public_path__ + "img/topBg.62af401d.png";